import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import {
  type GetSessionBillingBreakdownParams,
  type SessionBillingBreakdownResponse,
} from './get-session-billing-breakdown';
import {
  type V2HourlyTuitionPreviewResult,
  mapV2HourlyPreviewToSessionBillingBreakdown,
} from './map-v2-hourly-preview';

/**
 * V2 preview — POST /v2/hourly-tuitions/preview, mapped to the v1 breakdown shape
 * the review page already understands.
 */
export const getSessionBillingBreakdownV2API = async (
  params: GetSessionBillingBreakdownParams,
): Promise<SessionBillingBreakdownResponse> => {
  const { sessionId, fromDate, toDate } = params;

  const response = await baseAPI.post<V2HourlyTuitionPreviewResult>(
    '/v2/hourly-tuitions/preview',
    {
      sessionId,
      fromDate,
      toDate,
    },
  );

  return mapV2HourlyPreviewToSessionBillingBreakdown(
    response.data,
    fromDate,
    toDate,
  );
};

export const useGetSessionBillingBreakdownV2 = (
  params: GetSessionBillingBreakdownParams,
) => {
  return useQuery({
    queryKey: QUERY_KEYS.SESSION_BILLING_BREAKDOWN_V2(params),
    queryFn: () => getSessionBillingBreakdownV2API(params),
    enabled: false,
    staleTime: 1000 * 60 * 5,
  });
};
